<template>
	<div class="sidebar-ctn">
		<v-navigation-drawer v-model="drawer" :permanent="true" app>
			<a href="https://rubenjungbluth.com/">
			<img src="../assets/logo.png" alt="logo" class="logo"></a>
			<v-list dense>
				<v-list-item link :to="item.path" v-for="item in items" :key="item.path" @click="triggerFunction(item.method)">
					<v-list-item-content>
						<v-list-item-title>{{item.label}}</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</v-list>
			<div class="ctn-social">
				<a href="https://www.facebook.com/rubenjungbluth/" target="_blank">
					<img src="../assets/facebook.png" alt="">
				</a>
				<a href="https://www.youtube.com/channel/UCRx--IjbkKXKjCgpCDcJvdg" target="_blank">
					<img src="../assets/youtube.png" alt="">
				</a>
				<a href="https://www.instagram.com/rubenjungbluth/" target="_blank">
					<img src="../assets/instagram.png" alt="">
				</a>
			</div>
		</v-navigation-drawer>
		<v-dialog v-model="closeModalFlag" persistent max-width="350px" v-cloak>
			<v-card class="dialog-appointment">
				<v-btn class="mx-2 close-btn" x-small fab dark @click="closeModalFlag = !closeModalFlag" color="secondary lighten-4">
					<v-icon >mdi-close</v-icon>
				</v-btn>
				<v-card-title class="text-center mb-3">
					<img
						src="../assets/logo.png"
						alt="logo"
						class="logo">
				</v-card-title>
				<v-card-text class="text-center">
					¿Desea cerrar la sesión?
				</v-card-text>
				<v-card-actions class="pb-4 btn-size-auto">
					<v-spacer></v-spacer>
					<v-btn color="primary" small outlined @click="closeSesion">Si</v-btn>
					<v-btn color="primary" small @click="closeModalFlag = false">No</v-btn>
					<v-spacer></v-spacer>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>
<script>
  export default {
    name: 'Sidebar',

    data: () => ({
      closeModalFlag: false,
      items: [
        {
          label: 'Hola',
          path: '/',
        }, {
          label: 'Mi perfil',
          path: '/mi-perfil',
        }, {
          label: 'Mis consultas',
          path: '/consultas',
        }, {
          label: 'Carta astral',
          path: '/carta-astral',
        }, {
          label: 'Contacto',
          path: '/contacto',
        }, {
          label: 'Cerrar Sesión',
          method: 'closeModal',
        },
      ],
      drawer: true
    }),
		methods: {
      triggerFunction (fun) {
        if (fun) {
          this[fun]()
				} else {
          if (window.innerWidth < 769) {
            this.$emit('hideFlag')
					}
				}

			},
      closeModal () {
        this.closeModalFlag = !this.closeModalFlag
			},
      closeSesion () {
        localStorage.removeItem('token')
				location.href = 'https://rubenjungbluth.com/'
			}
		}
  }
</script>
<style lang="scss" scoped>
	$breakpoints: (
			'tablet': 768px,
	);
	@mixin mobile {
		@media screen and (max-width: map-get($breakpoints, tablet)) {
			@content;
		}
	}
	::v-deep .theme--light.v-navigation-drawer{
		background: #DFE3E6;
		padding: 30px 20px;
		@include mobile {
			width: 100% !important;
		}
		.v-list-item:hover {
			background: #ddd;
		}
		.v-list-item__title {
			font-size: 18px;
			font-weight: 600;
			text-transform: uppercase;
			padding: 10px 0 7px 0;
			color: #656565;
		}
		.v-list-item--active .v-list-item__title{
			color: #43A4BB;
		}
		.v-list-item--link:before {
			background-color: transparent;
		}
	}
	::v-deep .v-navigation-drawer__content {
		background: #fff;
		border-radius: 8px;
	}
	.logo {
		width: 75px;
		margin: 40px auto 50px;
		display: block;
	}
	.ctn-social {
		position: absolute;
		bottom: 40px;
		left: 0;
		right: 0;
		margin: 0 auto;
		text-align: center;
		width: 100%;
		a{
			img {
				width: 35px;
				margin: 0 7px 0 7px
			}
		}
	}
</style>
